module.exports = __webpack_public_path__ + "static/aquarell-0ff5dae427df712af9aa29b1adb37271.jpg";